var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view ingredients"},[_c('ingredients-cloud',{attrs:{"selected-pair":_vm.currentPair},on:{"select-pair":(pair)=>_vm.currentPair=pair}}),(_vm.currentPair)?_c('ingredient-pair-panel',{attrs:{"pair":_vm.currentPair},on:{"close":function($event){_vm.currentPair=null}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }